import TrackerList from 'common/pages/tracker/TrackerList.tsx'

export const TrackerAdvList = (props) => <TrackerList {...props} agency={false}/>